<template>
  <div v-if="isReadOnly">
    <div class="row mt-4 mb-5 ml-2">
      <div class="col-md-3 col col-sm-6">
        <total-amount-view
          :amount="getStringAmount | price"
          icon="fa fa-usd-circle"
          :icon-color="'color-yellow-star'"
          title="Reembolso Solicitado:"
        />
      </div>
      <div class="col-md-3 col col-sm-6 mt-3 mt-md-0 mt-sm-3">
        <total-amount-view
          :amount="model.adjustmentsTotal | price"
          icon="fa fa-usd-circle"
          icon-color="color-primary-8"
          title="Ajuste Realizado:"
        />
      </div>
      <div class="col-md-3 col col-sm-6 mt-md-0 mt-sm-3 mt-3 mt-md-0 mt-sm-3">
        <total-amount-view
          :amount="model.amountToRefund | price"
          icon="fa fa-usd-circle"
          icon-color="color-green"
          title="Total a Reembolsar:"
        />
      </div>
      <div
        v-if="data.isOneTimePayment"
        class="col-md-3 col col-sm-6 mt-md-0 mt-sm-3 mt-3 d-flex align-items-center"
      >
        <span class="badge badge-pill one-time-badge px-3 py-2 font-14">
          One Time Payment
        </span>
      </div>
    </div>
    <div>
      <section-title :has-line="true" title="Resumen General" />
      <custom-callout
        class="mb-4 custom-callout bg-white"
        :has-border="false"
        :has-toggle="false"
      >
        <div class="row py-2 mr-md-0 align-items-start">
          <div class="col-md-1 mt-5">
            <div
              class="
                    d-flex
                    flex-column
                    font-weight-bold
                    mt-n5
                    ml-n4
                    mt-sm-n5
                    ml-sm-n4
                    align-items-center
                  "
            >
              <span
                class="dot d-flex justify-content-center align-items-center py-2 px-1 mt-2"
              >
                <i class="orange-icon orange-icon-badge-align fas fa-donate" />
              </span>
            </div>
          </div>
          <div class="col-md-11">
            <div class="row mb-3">
              <div class="col-12">
                <span class="data-title d-block border-mobile font-weight-bold">
                  Periodo a Reembolsar:
                </span>
                <div class="d-flex">
                  <div
                    v-for="(period, index) in model.periods"
                    :key="`period-${index}`"
                    class="round-element mx-1"
                  >
                    <span
                      class="font-16 color-black text-nowrap font-weight-bold"
                    >
                      {{ period.periodName | uppercase }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <span
                  v-if="!data.isAdditionalPayment"
                  class="data-title d-block border-mobile mb-3"
                >
                  Desglose de los gastos solicitados en el {{ typeName }} para
                  el periodo seleccionado:
                </span>
                <span v-else class="data-title d-block border-mobile">
                  Detalle del pago adicional:
                </span>
                <p
                  v-if="
                    model &&
                      model.selectedServices.length == 0 &&
                      !data.isAdditionalPayment
                  "
                  class="font-14 color-black"
                >
                  {{ model.comment }}
                </p>
                <div
                  v-if="model && data.isAdditionalPayment"
                  class="font-14 color-black"
                >
                  <div class="col-12">
                    <span class="data-title d-block border-mobile">
                      Cantidad del Pago:
                    </span>
                    <span class="font-16 color-black">
                      $ {{ model.amount }}
                    </span>
                  </div>

                  <div class="col-12">
                    <span class="data-title d-block border-mobile">
                      Razón para el Pago:
                    </span>
                    <span class="font-16 color-black">
                      {{ model.additionalPaymentReason }}
                    </span>
                  </div>
                </div>
                <request-services
                  :is-mobile="isMobile"
                  :items="model.selectedServices"
                  :read-only="true"
                />
              </div>
            </div>
          </div>
        </div>
      </custom-callout>
    </div>
    <div>
      <section-title :has-line="true" title="Documentos" />
      <div class="mt-2 custom-document-info">
        <custom-callout :has-border="false" :has-toggle="false">
          <div class="row col-12">
            <div class="row col-8">
              <div class="row col-12 col-md-6">
                <div class="col-12">
                  <span class="data-title d-block border-mobile">
                    Documento:
                  </span>
                  <span class="font-16 color-black">
                    {{ 'Carta de Autorización' | empty }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-4 d-flex align-items-center justify-content-end">
              <action-button
                class="px-1 mx-1 download-btn"
                i="fas fa-file-download pl-2 m-0"
                variant="success"
                @click="onDownloadRefundReport"
              />
            </div>
          </div>
        </custom-callout>
      </div>
      <div
        v-for="(document, index) in filteredDocuments"
        :key="`document-${index}`"
      >
        <DocumentView
          v-if="
            !isReimbursementCertification(document.documentTypeId) ||
              document.documentId
          "
          :comment="document.comment"
          :document-file-name="document.documentFilename"
          :document-id="document.documentId"
          :document-name="document.documentTypeName"
          :document-type-id="document.documentTypeId"
          :request-id="model.requestId"
          :show-replace-button="
            !isServiceProposal(document.documentTypeId) &&
              !isReimbursementCertification(document.documentTypeId)
          "
        />
      </div>
    </div>
  </div>
  <div v-else>
    <validation-observer ref="formRef">
      <section-title
        id="reinbursement-selection-title"
        class="mt-4"
        has-line
        :title="
          isDirectPayment
            ? 'Selección de Periodo para Pago Directo'
            : data.isAdditionalPayment
            ? 'Periodo para Pago Adicional'
            : 'Selección de Periodo para Reembolso'
        "
      />
      <historial-accordion
        id="reinbursement-period"
        checkbox-container-class="pb-2"
        class="mt-3 mx-auto"
        :items="historialItems"
        topic-text="Periodo:"
        topic-text-class="font-weight-bold font-18"
        @on-checked-historial-item="updateItems"
      />
      <section-title
        id="reinbursement-service-amount-title"
        class="mt-4"
        has-line
        :title="
          isDirectPayment
            ? 'Información del Pago Directo'
            : data.isAdditionalPayment
            ? 'Información del Pago'
            : 'Información del Reembolso'
        "
      />
      <div
        v-if="!data.isAdditionalPayment"
        class="row menu rounded jumbo bg-light mt-4 p-4 mx-auto"
      >
        <label class="color-black font-16 col-12">
          Servicios autorizados por la Secretaría Asociada de Educación
          Especial.
        </label>

        <div class="my-3 col-12">
          <div v-if="!showNotServicesAvaiableMessage && !hasFoundServices">
            <CustomError
              is-alert-mode
              message="Para visualizar  los servicios favor de seleccionar el período correspondiente"
            />
          </div>
          <div v-if="showNotServicesAvaiableMessage" class="mb-2">
            <CustomError
              message="Para el período seleccionado no se encontró una consulta vigente"
              variant="no-border"
            />
          </div>

          <request-services
            v-if="servicesKey > 0"
            :key="servicesKey"
            :is-mobile="isMobile"
            :items="model.services"
            :request-status-id="model.statusId"
            :selected-month-number="selectedMonth"
            @on-select-services="onSelectServiceHandler"
            @update-amount="onUpdateAmountHandler"
          />
        </div>
        <validation-provider
          v-slot="{ errors }"
          class="col-12 px-0"
          :custom-messages="{
            required_if: isDirectPayment
              ? 'El monto para pago directo es requerido.'
              : 'El monto a reembolsar es requerido.',
          }"
          :rules="{ required_if: !model.amount }"
        >
          <CustomError
            v-if="errors[0] && errors[0].length > 0"
            :message="errors[0]"
            variant="no-border"
          />
        </validation-provider>
      </div>
      <div v-else class="row menu rounded jumbo bg-light mt-4 p-4 mx-auto">
        <div class="col-2">
          <validation-provider
            v-slot="{ errors }"
            :rules="'required|min_value:1'"
          >
            <custom-input
              v-model="model.amount"
              custom-error-msg="Entre la cantidad para el pago"
              :error="errors[0]"
              label="Cantidad del Pago"
              mask-type="Money"
              type="number"
            />
          </validation-provider>
        </div>
        <div class="col-12">
          <validation-provider v-slot="{ errors }" :rules="'required'">
            <custom-text-area
              id="comment"
              v-model="model.additionalPaymentReason"
              custom-error-msg="Por favor describa la razón para el pago"
              :error="errors[0]"
              label="Razón para el Pago"
              :maxlength="3000"
              name="comment"
              :show-char-count="true"
            />
          </validation-provider>
        </div>
      </div>
    </validation-observer>
    <validation-observer ref="documentFormRef">
      <section-title
        id="reinbursement-document-title"
        class="mt-4"
        has-line
        title="Documentos"
      />
      <custom-callout
        v-if="data.determinationId == 3"
        :has-border="false"
        :has-toggle="false"
      >
        <div class="row col-12 pr-0">
          <div class="row col-8">
            <div class="row col-12 col-md-6">
              <div class="col-12">
                <span class="data-title d-block border-mobile">
                  Documento:
                </span>
                <span class="font-16 color-black">
                  {{ 'Carta de Autorización' | empty }}
                </span>
              </div>
            </div>
          </div>
          <div class="col-4 d-flex align-items-center justify-content-end pr-0">
            <action-button
              i="fas fa-download p-1"
              variant="success download-btn"
              @click="onDownloadRefundReport"
            />
          </div>
        </div>
      </custom-callout>
      <template v-for="(item, index) in model.documents">
        <validation-provider
          v-if="!isReimbursementCertification(item.documentTypeId)"
          :key="`doc-validate-${index}`"
          v-slot="{ errors }"
          :custom-messages="{
            required_if: docValidationMessage(item),
          }"
          :disabled="isOther(item) ? 'disabled' : false"
          :rules="{ required_if: item.documentId }"
        >
          <reinbursement-documents
            :key="index"
            :auto-upload="false"
            :item="item"
            :proposal-documents="
              getProposalDocumentByDocumentTypeId(item.documentTypeId)
            "
            :request-id="data.requestId"
            @on-refresh-data="onUpdateDocument"
          />
          <custom-error
            v-if="errors[0] && errors[0].length > 0"
            :message="'El documento es requerido.'"
            variant="no-border"
          />
        </validation-provider>
        <DocumentView
          v-else-if="item.documentId"
          :key="`cert-doc-${index}`"
          :can-add-document="false"
          :document-file-name="item.documentFilename"
          :document-id="item.documentId"
          :document-name="item.documentTypeName"
          :document-type-id="item.documentTypeId"
          :request-id="data.requestId"
          :show-replace-button="false"
        />
      </template>
    </validation-observer>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import CustomInput from 'CustomInput';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { submitRequest as _submitRequest } from '@/modules/reinbursement/api';
import CustomCallout from 'custom-callout';
import SectionTitle from 'SectionTitle';
import HistorialAccordion from '@/components/common/SingleHistorialAccordion.vue';
import CustomError from 'custom-error';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import DocumentView from './DocumentView.vue';
import TotalAmountView from './TotalAmountView.vue';
import RequestServices from './RequestServices.vue';
import ReinbursementDocuments from './ReinbursementDocuments.vue';
import disbursementRequestStatuses from '@/utils/shared/constants/disbursementRequestStatuses';
import { monthsString, monthsNumber } from '@/utils/constants/months';
import codeDocumentTypes from '@/utils/constants/documentTypes';
import alertMixin from '@/mixins/alert.mixin';
import AppServices from '@/modules/app/api.js';
import determinationTypes from '@/utils/constants/determinationTypes';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import sysparameterByNames from '@/utils/constants/sysParameterNames';
import { serialize as objectToFormData } from 'object-to-formdata';
import {
  getServicesByPeriod as _getServicesByPeriod,
  getBlockedPeriods as _getBlockedPeriods,
} from '@/modules/reinbursement/api.js';
// store
import { name as appModuleName } from '@/modules/app/store/index';

const STATUS_NAME = {
  Sometido: 'Sometido',
  SometidoRevisado: 'Sometido Revisado',
};

export default {
  name: 'ReinbusementDetailResume',
  components: {
    CustomInput,
    CustomTextArea,
    CustomCallout,
    SectionTitle,
    TotalAmountView,
    DocumentView,
    HistorialAccordion,
    CustomError,
    ValidationObserver,
    ValidationProvider,
    ReinbursementDocuments,
    RequestServices,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    proposalDocuments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedMonth: null,
      model: {
        requestId: 0,
        requestNumber: null,
        tapRequestNumber: null,
        determination: null,
        statusId: 0,
        statusName: null,
        academicYearId: 0,
        academicYearDescription: null,
        amount: 0,
        periods: null,
        documents: null,
        comment: null,
        amountToRefund: null,
        selectedServices: [],
        additionalPaymentReason: null,
        services: [],
        blockedPeriods: [],
      },
      servicesKey: 0,
      historialItems: [],
      file: null,
      wasFormValidated: false,
      startDateDirectPaymentRequest: null,
      showNotServicesAvaiableMessage: false,
      codeDocumentTypes: codeDocumentTypes,
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
    }),
    getStringAmount() {
      return this.totalAmount.toString();
    },
    typeName() {
      return this.isDirectPayment ? 'pago directo' : 'reembolso';
    },
    checkPeriods() {
      return this.historialItems.filter((i) => i.isChecked);
    },
    canShowSubmitAction() {
      return (
        this.model.statusId === disbursementRequestStatuses.Nuevo ||
        this.model.statusId === disbursementRequestStatuses.DevueltoARevisión
      );
    },
    academicYearId() {
      return this.$route.params.academicYearId != null
        ? +this.$route.params.academicYearId
        : 0;
    },
    institutionId() {
      return this.$route.params.institutionId != null
        ? +this.$route.params.institutionId
        : 0;
    },
    tapRequestId() {
      return this.$route.params.tapRequestId != null
        ? +this.$route.params.tapRequestId
        : 0;
    },
    requestTypeId() {
      return this.$route.params.requestTypeId != null
        ? +this.$route.params.requestTypeId
        : 0;
    },
    ssn() {
      return this.$route.params.ssn != null ? this.$route.params.ssn : '';
    },
    tapRequestNumber() {
      return this.$route.params.tapRequestNumber != null
        ? this.$route.params.tapRequestNumber
        : '';
    },
    docValidationMessage() {
      return (item) => {
        switch (item.documentTypeId) {
          case codeDocumentTypes.PaymentCertificate:
            return 'El documento de certificado de pago es requerido.';
          case codeDocumentTypes.EvidencePaymentReceipt:
            return 'El documento de evidencia recibo de pago es requerido.';
          default:
            return '';
        }
      };
    },
    isOther() {
      return (item) => item.documentTypeId === codeDocumentTypes.Other;
    },
    startDate() {
      const date = this.model?.assignmentStartDate;
      return date ? moment(date) : '';
    },
    endDate() {
      const date = this.model?.assignmentEndDate;
      return date ? moment(date) : '';
    },
    isCheckedPeriodWithinEffectiveDate() {
      if (!this.checkPeriods.length) return false;
      const period = this.checkPeriods[0];
      const periodDate = moment({
        year: Number(period.subtitle),
        month: period.monthNumber - 1,
      });
      periodDate.set('date', periodDate.daysInMonth());
      return periodDate >= this.startDate && periodDate <= this.endDate;
    },
    isReimbursementCertification() {
      return (documentTypeId) =>
        documentTypeId === codeDocumentTypes.ReimbursementCertification;
    },
    isServiceProposal() {
      const invalid = [
        codeDocumentTypes.ServiceProposalFacilitator,
        codeDocumentTypes.ServiceProposalDirector,
        codeDocumentTypes.ServiceProposalCentralLevel,
        codeDocumentTypes.ServiceProposal,
      ];
      return (documentTypeId) => invalid.includes(documentTypeId);
    },
    totalAmount() {
      return Number(this.model?.amount ?? 0);
    },
    isDirectPayment() {
      return determinationTypes.DirectPayment === this.data?.determinationId;
    },
    hasFoundServices() {
      return this.model?.services?.length > 0;
    },
    isReturnToReview() {
      return (
        this.model.statusId === disbursementRequestStatuses.DevueltoARevisión
      );
    },
    filteredDocuments() {
      return this.model.documents?.filter(
        //Este documento se genera y guarda, acederlo se logra por elemento previo a esta lista
        (d) => d.documentTypeId !== codeDocumentTypes.CartaAprobacionReembolso
      );
    },
  },
  watch: {
    checkPeriods(newVal) {
      this.$emit('on-check-period', newVal);
    },
    'model.comment'(newVal) {
      this.$emit('on-comment-change', newVal);
    },
    'data.amountToRefund'(newVal) {
      this.model.amountToRefund = newVal;
    },
    'data.selectedServices'(newVal) {
      this.model.selectedServices = newVal;
    },
  },
  async mounted() {
    this.model = Object.assign(this.model, this.data);
    await Promise.all([this.getParameter(), this.getBlockedPeriods()]);
    this.loadSelectionPeriod();
    this.loadSelectedServices();

    if (this.checkPeriods.length) {
      const period = this.checkPeriods[0];
      await this.getServicesByPeriod(period.monthNumber, period.subtitle);
    }
  },
  methods: {
    async updateItems(items) {
      if (!this.isCheckedPeriodWithinEffectiveDate) {
        this.ShowToast(
          'Alerta',
          'No es posible seleccionar el periodo, ya que no se encuentra dentro de la vigencia de la consulta.',
          'error'
        );
        this.historialItems.forEach((x) => (x.isChecked = false));
      }

      const selectedItem = items.find((x) => x.isChecked);
      if (!selectedItem) return;

      await this.getServicesByPeriod(
        selectedItem.monthNumber,
        selectedItem.subtitle
      );
    },
    async getBlockedPeriods() {
      var { data } = await _getBlockedPeriods(
        this.model.studentSieId,
        this.model.requestId
      );
      this.model.blockedPeriods =
        Array.isArray(data) && data.length > 0
          ? data
          : Array.isArray(this.data.blockedPeriods)
          ? this.data.blockedPeriods
          : [];
    },
    async getServicesByPeriod(month, year) {
      this.selectedMonth = month;
      this.showNotServicesAvaiableMessage = false;
      year = Number(year);

      const { data } = await _getServicesByPeriod(
        this.model.studentSieId,
        month,
        year
      );
      this.model.services = data;

      // show error message if no services are available
      if (data.length === 0) this.showNotServicesAvaiableMessage = true;
    },
    loadSelectedServices() {
      this.model.services?.map((service) => {
        service.checked = this.model.selectedServices.some(
          (x) => x.serviceId == service.id
        );
      });
      this.model.selectedServices?.map((service) => {
        service.tapCentralServiceId = service.serviceId;
      });
      this.servicesKey++;
    },
    loadSelectionPeriod() {
      const years = this.model.academicYearDescription.split('-');
      const { periods, blockedPeriods } = this.model;
      const currentDate = new Date();
      const readOnly =
        this.data.isAdditionalPayment ||
        (this.isDirectPayment && this.isReturnToReview);

      this.historialItems = [
        {
          title: monthsString.JUL,
          subtitle: years[0],
          monthNumber: monthsNumber[monthsString.JUL],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.JUL),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.JUL
          ),
          isDisabled: this.isPeriodDisabled(
            years[0],
            monthsNumber.JUL,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.AGO,
          subtitle: years[0],
          monthNumber: monthsNumber[monthsString.AGO],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.AGO),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.AGO
          ),
          isDisabled: this.isPeriodDisabled(
            years[0],
            monthsNumber.AGO,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.SEPT,
          subtitle: years[0],
          monthNumber: monthsNumber[monthsString.SEPT],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.SEPT),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.SEPT
          ),
          isDisabled: this.isPeriodDisabled(
            years[0],
            monthsNumber.SEPT,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.OCT,
          subtitle: years[0],
          monthNumber: monthsNumber[monthsString.OCT],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.OCT),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.OCT
          ),
          isDisabled: this.isPeriodDisabled(
            years[0],
            monthsNumber.OCT,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.NOV,
          subtitle: years[0],
          monthNumber: monthsNumber[monthsString.NOV],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.NOV),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.NOV
          ),
          isDisabled: this.isPeriodDisabled(
            years[0],
            monthsNumber.NOV,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.DIC,
          subtitle: years[0],
          monthNumber: monthsNumber[monthsString.DIC],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.DIC),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.DIC
          ),
          isDisabled: this.isPeriodDisabled(
            years[0],
            monthsNumber.DIC,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.ENE,
          subtitle: years[1],
          monthNumber: monthsNumber[monthsString.ENE],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.ENE),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.ENE
          ),
          isDisabled: this.isPeriodDisabled(
            years[1],
            monthsNumber.ENE,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.FEB,
          subtitle: years[1],
          monthNumber: monthsNumber[monthsString.FEB],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.FEB),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.FEB
          ),
          isDisabled: this.isPeriodDisabled(
            years[1],
            monthsNumber.FEB,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.MAR,
          subtitle: years[1],
          monthNumber: monthsNumber[monthsString.MAR],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.MAR),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.MAR
          ),
          isDisabled: this.isPeriodDisabled(
            years[1],
            monthsNumber.MAR,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.ABR,
          subtitle: years[1],
          monthNumber: monthsNumber[monthsString.ABR],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.ABR),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.ABR
          ),
          isDisabled: this.isPeriodDisabled(
            years[1],
            monthsNumber.ABR,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.MAY,
          subtitle: years[1],
          monthNumber: monthsNumber[monthsString.MAY],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.MAY),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.MAY
          ),
          isDisabled: this.isPeriodDisabled(
            years[1],
            monthsNumber.MAY,
            currentDate
          ),
          readonly: readOnly,
        },
        {
          title: monthsString.JUN,
          subtitle: years[1],
          monthNumber: monthsNumber[monthsString.JUN],
          isChecked: periods?.some((x) => x.monthNumber === monthsNumber.JUN),
          isBlocked: blockedPeriods?.some(
            (x) => x.monthNumber === monthsNumber.JUN
          ),
          isDisabled: this.isPeriodDisabled(
            years[1],
            monthsNumber.JUN,
            currentDate
          ),
          readonly: readOnly,
        },
      ];
    },
    isFutureSelection(fiscalYear, monthNumber, currentDate) {
      const tempDate = new Date(fiscalYear, monthNumber, 1);
      return currentDate < tempDate;
    },
    isPeriodDisabled(fiscalYear, monthNumber, currentDate) {
      return (
        (this.isDirectPayment &&
          this.startDateDirectPaymentRequest != null &&
          this.startDateDirectPaymentRequest >
            new Date(fiscalYear, monthNumber, 1)) ||
        this.isFutureSelection(fiscalYear, monthNumber, currentDate)
      );
    },
    onUpdateAmountHandler(newTotal) {
      this.model.amount = Number(newTotal);
    },
    onSelectServiceHandler(val) {
      this.model.selectedServices = val?.map((item) => {
        return {
          ...item,
          disbursementRequestId: this.model.requestId,
          tapCentralServiceId: item.id,
        };
      });
    },
    async onUpdateDocument(newVal) {
      this.model.documents = this.model.documents.map((doc) =>
        doc.documentTypeId === newVal.documentTypeId
          ? {
              ...doc,
              documentId: '1',
              file: newVal.file,
            }
          : doc
      );
      if (this.wasFormValidated) {
        this.$nextTick(async () => await this.$refs.documentFormRef.validate());
      }
    },
    async submit() {
      this.wasFormValidated = true;
      if (!this.historialItems.some((x) => x.isChecked)) {
        const alertMessage = this.isDirectPayment
          ? 'Favor seleccionar un periodo a pagar directo.'
          : 'Favor seleccionar un periodo a reembolsar.';
        this.ShowToast('Alerta', alertMessage, 'error');
        return false;
      }

      const isValid = await this.$refs.formRef.validate();
      const docFormIsValid = await this.$refs.documentFormRef.validate();

      if (!isValid || !docFormIsValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return false;
      }
      let message = '';
      let comment = '';
      let status = null;

      if (this.model.statusId == disbursementRequestStatuses.Nuevo) {
        message = `¿Está seguro(a) que desea someter la solicitud de ${this.typeName}?`;
        comment = 'Información de solicitud ha sido sometida.';
        status = disbursementRequestStatuses.Sometido;
      } else if (
        this.model.statusId == disbursementRequestStatuses.DevueltoARevisión
      ) {
        message = `¿Está seguro(a) que desea someter la revisión de la solicitud de ${this.typeName}  ${this.model.requestNumber}`;
        comment = 'Información de solicitud ha sido revisada.';
        status = disbursementRequestStatuses.SometidoRevisado;
      }
      const answer = await this.ShowCancelModal(
        'Confirmación',
        message,
        'Sí',
        'No'
      );

      if (!answer) return false;

      const requestData = {
        preRequest: {
          ssn: this.ssn === 0 ? '' : this.ssn,
          academicYearId: this.academicYearId,
          tapRequestId: this.tapRequestId,
          requestTypeId: this.requestTypeId,
          institutionId: this.institutionId,
          number: this.tapRequestNumber,
        },
        request: {
          requestId: this.model.requestId,
          periods: this.checkPeriods.map((p) => ({
            requestId: this.model.requestId,
            monthNumber: p.monthNumber,
          })),
          selectedServices: this.model.selectedServices,
          amount: this.totalAmount,
          comment: this.model.comment,
          statusComment: comment,
          newDisbursementRequestStatus: status,
          additionalPaymentReason: this.model.additionalPaymentReason,
        },
      };

      let payload = objectToFormData(requestData, {
        indices: true,
        nullsAsUndefineds: true,
        dotsForObjectNotation: true,
      });

      const files = this.model.documents.filter((x) => x.file != null);

      (files || []).forEach((document, index) => {
        payload.append(`files[${index}].file`, document.file);
        payload.append(
          `files[${index}].documentTypeId`,
          document.documentTypeId
        );
      });

      try {
        const { data } = await _submitRequest(payload);

        if (data.isValid) {
          this.model.periods = this.checkPeriods.map((p) => ({
            ...p,
            periodName: `${p.title} ${p.subtitle}`,
          }));
          this.model.statusId = status;
          this.model.statusName = status ? '' : '';
          if (status == disbursementRequestStatuses.SometidoRevisado) {
            this.model.statusName = STATUS_NAME.SometidoRevisado;
          }
          if (status == disbursementRequestStatuses.Sometido) {
            this.model.statusName = STATUS_NAME.Sometido;
          }
          this.ShowToast(
            'Proceso Exitoso.',
            `La solicitud de ${this.typeName} ha sido sometida exitosamente.`,
            'success'
          );
          const editing = !!this.model.requestId;
          this.model.requestId = data.requestId;
          if (editing) {
            this.$emit('refresh-data');
          } else {
            this.$router.push({
              name: 'ReimbursementDetail',
              params: {
                requestId: data.requestId,
              },
            });
          }
        } else this.ShowToast('Alerta', data.message, 'error');
      } catch (err) {
        this.ShowToast('Alerta', err.response.data.message || 'error', 'error');
      }
    },
    async onDownloadRefundReport() {
      const { tapRequestId } = this.model;
      const id = tapRequestId || this.data.tapRequestId;
      if (this.isDirectPayment) {
        await AppServices.getTapRequestDirectPaymentReport({
          requestId: id,
        });
      } else {
        await AppServices.getTapRequestRefundReport(this.model.requestId);
      }
    },
    async getParameter() {
      const { data } = await _getSysparameterByNames({
        parameterNames: [sysparameterByNames.StartDateDirectPaymentRequest],
      });

      this.startDateDirectPaymentRequest = new Date(
        data.find(
          (x) => x.name == sysparameterByNames.StartDateDirectPaymentRequest
        ).staticValue
      );
    },
    getProposalDocumentByDocumentTypeId(documentTypeId) {
      const documentTypesEnum = Object.freeze({
        DirectorPropuestaServicios: 196,
        PropuestaServicios: 191,
        NivelCentralPropuestaServicios: 209,
        TapRequestPropuestaServicios: 219,
      });

      const proposalTypes = Object.values(documentTypesEnum);

      if (proposalTypes.some((x) => x === documentTypeId)) {
        return this.proposalDocuments;
      }

      return [];
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/shared/scss/config/_colors.scss';

::v-deep .input-group-prepend.success .input-group-text {
  background: map.get($colors, 'green') !important;
  color: map.get($colors, 'white') !important;
}

.one-time-badge {
  background-color: map.get($colors, 'orange');
  color: map.get($colors, 'white');
}

.round-element {
  background-color: #ffffff !important;
  border-radius: 50px;
  border: 1px solid #aabbb4;
  padding: 15px;
  width: 90px;
  height: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tag-badge {
  display: flex;
  align-items: center;
  padding-right: 1em;
  height: 43px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  margin-bottom: 10px;
}

.dot {
  width: 41px;
  height: 41px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ff7058 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
  padding: 22px !important;
  border: 3px solid #fff;
}
.orange-icon {
  color: #ffffff;
  font-size: 16pt;
  padding-right: 4px;
  line-height: 25px;
  margin-left: 4px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}

@media screen and (max-width: 600px) {
  .tag-badge-title {
    font-size: 1em;
  }
}
@media (max-width: 375px) {
  .student-search-alert-error.no-border p {
    font-size: 12px;
  }
}
.student-search-alert-error.alert p,
.student-search-alert-error.alert em {
  color: #af6708;
}
.student-search-alert-error.alert {
  background: #fff5e8;
  border: 1px solid #fdac41;
}
</style>
